import { render, staticRenderFns } from "./farm.vue?vue&type=template&id=e49bd0f6&scoped=true&"
import script from "./farm.vue?vue&type=script&lang=js&"
export * from "./farm.vue?vue&type=script&lang=js&"
import style0 from "./farm.vue?vue&type=style&index=0&id=e49bd0f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49bd0f6",
  null
  
)

export default component.exports